/* eslint-disable no-sequences */
import React from 'react';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { ReorderFuncionalidadesModel } from './reorderFuncionalidades.model';
import Return from '../../../images/return.png';
import { FaRegBell } from 'react-icons/fa';
import { BaSeButton } from '@base/react';
import { BaSeDialogContext, BaSeTheme } from '@base/react';
import './style.scss';

export const ReorderFuncionalidades = (props) => {
  const { showModal } = React.useContext(BaSeDialogContext);
  const { tipos, onClose, setActionDone } = props;

  const { tipo, setTipo, dataType, updateOrder, saveOrder, isLoading } =
    ReorderFuncionalidadesModel(props);

  const backList = () => {
    onClose();
  };

  const handleActionClick = ({
    title,
    content,
    actionTitle,
    titleSuccess,
    msgSuccess,
    titleError,
    msgError,
    reloadPage,
  }) => {
    const Sim = 'Ok';
    const Nao = 'Não';

    const actions = {
      [Sim]: async () => {
        const response = await actionTitle();
        const innerActions = {
          [Sim]: () => console.log('Fechado'),
        };

        let configReturn;
        if (response.status === 200) {
          configReturn = {
            // Entradas
            actions: [
              {
                action: Sim,
                type: 'primary',
                color: BaSeTheme.colors.feedbackInterface.sucesso20,
              },
            ],
            title: titleSuccess,
            titleColor: BaSeTheme.colors.institucionais.cinzaSebrae45, // Quando não passar, assume-se o valor #617385
            dismissable: true, // Quando não passar, assume-se o valor `true`
            content: () => <>{msgSuccess()}</>,
            onOpen: () => console.log('>>> Abriu a modal'),
            onChooseAction: (action) => innerActions?.[action]?.(),
            onDismiss: () =>
              console.log('>>> Modal fechou no cancelar (ou clicando fora)'),
            afterClose: () => console.log('>>> Modal fechada'),
          };

          if (reloadPage) setActionDone(true);
        } else {
          configReturn = {
            // Entradas
            actions: [
              {
                action: Sim,
                type: 'primary',
                color: BaSeTheme.colors.feedbackInterface.sucesso20,
              },
            ],
            title: titleError,
            titleColor: BaSeTheme.colors.institucionais.erro45, // Quando não passar, assume-se o valor #617385
            dismissable: true, // Quando não passar, assume-se o valor `true`
            content: () => <>{msgError()}</>,
            onOpen: () => console.log('>>> Abriu a modal'),
            onChooseAction: (action) => innerActions?.[action]?.(),
            onDismiss: () =>
              console.log('>>> Modal fechou no cancelar (ou clicando fora)'),
            afterClose: () => console.log('>>> Modal fechada'),
          };
        }

        showModal(configReturn);
      },
    };

    const config = {
      // Entradas
      actions: [
        {
          action: Sim,
          type: 'primary',
          color: BaSeTheme.colors.feedbackInterface.sucesso20,
        },
        {
          action: Nao,
          type: 'primary',
          color: BaSeTheme.colors.feedbackInterface.erro45,
        },
      ],
      title: title,
      titleColor: BaSeTheme.colors.institucionais.cinzaSebrae45, // Quando não passar, assume-se o valor #617385
      dismissable: true, // Quando não passar, assume-se o valor `true`
      content: () => <>{content()}</>,
      onOpen: () => console.log('>>> Abriu a modal'),
      onChooseAction: (action) => actions?.[action]?.(),
      onDismiss: () =>
        console.log('>>> Modal fechou no cancelar (ou clicando fora)'),
      afterClose: () => console.log('>>> Modal fechada'),
    };

    showModal(config);
  };

  return (
    <div>
      <div className="container-principal">
        <div
          className="filtro-container"
          style={{ backgroundColor: '#cc6633' }}
        >
          <div className="modal-flex-direction-row">
            <FaRegBell size={40} color="#ffffff" />
            <h2 className="text-color-branco-titulo">Perguntas frequentes</h2>
            <div className="div-acoes-carrossel">
              <div className="icons-acoes-modal-filtro">
                <img
                  onClick={backList}
                  alt="imagem"
                  className="writin"
                  src={Return}
                />
                <p className="text-color-branco">Voltar</p>
              </div>
            </div>
          </div>
        </div>
        <hr size="1" className="separador-servicos"></hr>

        <div className="filters-content">
          <div
            className="filter-container"
            style={{ borderBottom: '1px solid #cc6633' }}
          >
            <h3 style={{ color: '#cc6633' }}>Organizar</h3>
          </div>
          <div className="div-acoes-funcionalidade">
            <div className="container-itens">
              <p className="text-campos-cadastro">
                Assunto<span className="mandatory-diagnostico">*</span>
              </p>
              <div className="button-container">
                <select
                  onChange={(e) => setTipo(e.target.value)}
                  className="btn-select-perguntas height-36"
                  value={tipo}
                >
                  <option value={''}>Todos</option>
                  {tipos.map((tp) => (
                    <option value={tp.id} title={tp.nome}>
                      {tp.nome}
                    </option>
                  ))}
                </select>
                <BaSeButton
                  width={100}
                  value="Salvar"
                  color="#cc6633"
                  onClick={() =>
                    handleActionClick({
                      content: () => {
                        return (
                          <label>
                            Ao <strong>{'SALVAR, '}</strong> as perguntas serão
                            apresentadas no App nesta ordem. Deseja continuar?
                          </label>
                        );
                      },
                      title: 'Organizar',
                      actionTitle: () => saveOrder(),
                      titleSuccess: 'Sucesso',
                      msgSuccess: () => (
                        <label>
                          A organização das perguntas foi realizada com sucesso!
                        </label>
                      ),
                      titleError: 'Erro.',
                      msgError: () => (
                        <label>
                          A organização das perguntas não foi realizada.
                          Aconteceu um erro ou o sistema está temporariamente
                          fora do ar. Tente novamente mais tarde.
                        </label>
                      ),
                      reloadPage: true,
                    })
                  }
                />
              </div>
            </div>
          </div>

          <div className="background-grey m-t-30 padding-container">
            <div
              className="container-draggable"
              style={{ borderBottom: '1px solid #cc6633' }}
            >
              <text className="id-container bold-perguntas">Ordem</text>
              {tipo === '' && (
                <text className="titulo-container bold-perguntas">
                  Assuntos
                </text>
              )}
              {tipo !== '' && (
                <>
                  <text className="titulo-container bold-perguntas">
                    Pergunta
                  </text>
                  <text className="titulo-container bold-perguntas">
                    Resposta
                  </text>
                </>
              )}
            </div>

            {isLoading ? (
              <div
                className="container-draggable"
                style={{ borderBottom: '1px solid #cc6633' }}
              >
                <text>Carregando</text>
              </div>
            ) : (
              <DragDropContext onDragEnd={updateOrder}>
                <Droppable droppableId="characters">
                  {(provided) => (
                    <div
                      className="characters background-grey"
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      {dataType.map((el, index) => (
                        <Draggable
                          key={`${el.id}`}
                          draggableId={`${el.id}`}
                          index={index}
                        >
                          {(providedDragabble) => (
                            <div
                              className="container-draggable"
                              ref={providedDragabble.innerRef}
                              {...providedDragabble.draggableProps}
                              {...providedDragabble.dragHandleProps}
                            >
                              <text className="id-container bold-perguntas">
                                {index + 1}
                              </text>
                              {tipo === '' && (
                                <text className="titulo-container color-grey">
                                  {el.nome}
                                </text>
                              )}
                              {tipo !== '' && (
                                <>
                                  <text className="titulo-container color-grey">
                                    {el.pergunta}
                                  </text>
                                  <text className="titulo-container color-grey">
                                    {el.resposta}
                                  </text>
                                </>
                              )}
                            </div>
                          )}
                        </Draggable>
                      ))}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
